import React from "react"

const FilterCloseButton = ({ onClick, isWhite }) => {
    const style = {
        marginLeft: "10px"
    }
    if (isWhite) {
        style.color = "white"
    }
    return (
        <button
            type="button"
            className="close filter-close"
            aria-label="close"
            onClick={onClick}
            style={style}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    )
}

export default FilterCloseButton
